/** BIDV returns either an image URL, a data URL, or raw PNG Base64. */
export const getQrImageSource = (image?: string | null): string => {
  const source = image?.trim() || '';
  if (!source) return '';
  if (/^(https?:\/\/|data:|blob:|\/)/i.test(source)) return source;
  return `data:image/png;base64,${source.replace(/\s/g, '')}`;
};
